import script from "./LogsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./LogsTable.vue?vue&type=script&setup=true&lang=js"

import "./LogsTable.vue?vue&type=style&index=0&id=f44e0582&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f44e0582"]])

export default __exports__